import { DatePipe } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import Chart from 'chart.js/auto';
import { subMonths } from 'date-fns';
import * as _ from 'lodash';

import { ChartColors, OpportunityActivitySummary } from '@features/reports/models/opportunity-activity-summary';

@Component({
  selector: 'spark-reports-opportunities-chart',
  templateUrl: './opportunity.component.html',
  styleUrls: ['./opportunity.component.scss']
})
export class OpportunityChartComponent implements OnInit, OnDestroy {
  private oppChart!: Chart;
  @Input() opportunities: OpportunityActivitySummary[] = [];
  @Output() hoverIndexChange = new EventEmitter<number>();

  ngOnInit(): void {
    this.createChart();
  }

  ngOnDestroy(): void {
    this.oppChart.destroy();
  }

  private generateDefaultLabels(datePipe: DatePipe): string[] {
    const now = new Date();
    return Array.from({ length: 12 }, (_, i) => {
      const date = subMonths(now, 11 - i);
      return datePipe.transform(date, 'MMM')?.toLocaleUpperCase() ?? '';
    });
  }

  private createChart() {
    const data = this.opportunities;
    const datePipe = new DatePipe('en-AU');

    if (this.oppChart) {
      this.oppChart.destroy();
    }

    const labels = data.length > 0
      ? _.map(data, 'period').map((x) =>
          datePipe.transform(x, 'MMM')?.toLocaleUpperCase()
        )
      : this.generateDefaultLabels(datePipe);

    this.oppChart = new Chart('opportunity-chart', {
      type: 'line',
      data: {
        labels,
        datasets: [
          {
            label: 'Home loans',
            data: _.map(data, 'home'),
            borderColor: ChartColors.Blue
          },
          {
            label: 'SMSF loans',
            data: _.map(data, 'smsf'),
            borderColor: ChartColors.Green
          },
          {
            label: 'Personal loans',
            data: _.map(data, 'personal'),
            borderColor: ChartColors.Yellow
          },
          {
            label: 'Car loans',
            data: _.map(data, 'car'),
            borderColor: ChartColors.Red
          },
          {
            label: 'Refix loans',
            data: _.map(data, 'refix'),
            borderColor: ChartColors.Red
          },
          {
            label: 'Insurance',
            data: _.map(data, 'insurance'),
            borderColor: ChartColors.Green
          }
        ]
      },
      options: {
        responsive: false,
        aspectRatio: 2,
        elements: {
          point: {
            pointStyle: false
          }
        },
        interaction: {
          mode: 'index',
          axis: 'x',
          intersect: false
        },
        onHover: (e, els, chart) => {
          if (els?.length > 0) {
            this.hoverIndexChange.emit(els[0].index);
          }
        },
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            enabled: false
          }
        },
        scales: {
          x: {
            grid: {
              display: false
            },
            ticks: {
              color: '#d6dbe1'
            },
            border: {
              color: '#d6dbe1'
            }
          },
          y: {
            grid: {
              display: false
            },
            ticks: {
              color: '#d6dbe1',
              precision: 0
            },
            border: {
              color: '#d6dbe1'
            }
          }
        }
      }
    });
  }
}
